import { useState } from "react";
import { useSearchParams } from "react-router-dom"
import { useDispatch } from "react-redux";
import { Box, Typography, Grid } from "@mui/material"
import { useFormik } from 'formik';

import BaseImage from "../../components/BaseImage"
import BaseColorText from "../../components/BaseColorText";
import BaseButton from "../../components/BaseButton";
import InputPassword from "../../components/InputPassword";
import HelpText from "../../components/HelpText";

import LeftSideBanner from "../../assets/images/auth/left_side_banner.svg"
import LogoBlue from "../../assets/images/logo/dDNA_logo_blue.svg"

import { confirmThePasswordReset } from "../../api-services/auth";
import { showErrorToast } from "../../utils/toast";
import { validationsResetPasswordSchema } from "../../validations/validationSignUpSchema";
import { openModal } from "../../store";

/**
 * @param {Object} props
 */
const ResetPassword = () => {
  const dispatch = useDispatch()
  const [searchParams] = useSearchParams()

  let oobCode = searchParams.get('oobCode')

  const [isLoading, setIsLoading] = useState(false)
  const { errors, handleBlur, handleChange, handleSubmit, touched, values } =
    useFormik({
      validateOnBlur: true,
      initialValues: {
        password: '',
        confirmPassword: ''
      },
      validationSchema: validationsResetPasswordSchema,
      onSubmit: async (values, { setSubmitting }) => {
        setIsLoading(true);
        confirmThePasswordReset(oobCode, values.password)
        .then(() => {
          setIsLoading(false);
          dispatch(
            openModal({
              currentModal: 'RESET_PASSWORD_CONFIRM_MODAL',
          }))
        })
        .catch(error => {
          return showErrorToast({
            message: error.message
          })
        })
        .finally(() => {
          setIsLoading(false)
        })
      }
    });

  return (
    <Box>
      <Grid container spacing={2}>
        <Grid item xs={6} sx={{
          display: { xs: 'none', md: 'block' },
        }}>
          <Box
            sx={{
              padding: '8px',
              width: '100%',
              height: '100%',
            }}
          >
            <Box
              sx={{
                width: '100%',
                height: '100%',
                bgcolor: 'primary.black',
                borderRadius: '10px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <BaseImage
                sx={{
                  width: '580px',
                  height: '541px',
                }}
                sximage={{
                  objectFit: 'cover'
                }}
                src={LeftSideBanner} alt='left-side-banner' 
              />
            </Box>
          </Box>
        </Grid>
        <Grid item xs={12} md={6}>
          <Box
            sx={{
              padding: '20px',
              display: 'flex',
              justifyContent: 'center',
              height: '100vh'
            }}
          >
            <Box sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              width: '390px',
              padding: '20px'
            }}>
              <BaseImage
                sx={{
                  mt: { md: '20px' },
                  width: '158px'
                }}
                src={LogoBlue}
              />
              <Box sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                height: '100%'
              }}>
                <Box sx={{
                  width: '100%',
                  mt: '70px'
                }}>
                  <Typography variant="h1">
                    Enter your new <br /><BaseColorText isGradient gradientColor='#5A3BC7 30%, #5FB2EC 90%'>password</BaseColorText>
                  </Typography>
                  <Box sx={{
                    mt: '20px',
                  }}>
                    <form onSubmit={handleSubmit}>
                      <InputPassword
                        sx={{
                          mt: '20px',
                        }}
                        fullWidth
                        label='Password'
                        name='password'
                        placeholder='Create a password'
                        value={values.password || ''}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        helperText={touched.password ? errors.password : ""}
                        error={touched.password && Boolean(errors.password)}
                        required
                      />
                      <InputPassword
                        sx={{
                          mt: '20px',
                        }}
                        fullWidth
                        label='Confirm password'
                        name='confirmPassword'
                        placeholder='Confirm password'
                        value={values.confirmPassword || ''}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        helperText={touched.confirmPassword ? errors.confirmPassword : ""}
                        error={touched.confirmPassword && Boolean(errors.confirmPassword)}
                        required
                      />
                      <BaseButton
                        loading={isLoading}
                        disabled={isLoading || Object.entries(errors).length !== 0}
                        variant='contained'
                        buttonType='primary'
                        type='submit'
                        sx={{
                          mt: { xs: '30px', sm: '50px' },
                        }}
                      >
                        Continue to log in
                      </BaseButton>
                    </form>
                  </Box>
                </Box>
                <Box
                  sx={{
                    mt: '80px'
                  }}
                >
                  <HelpText sx={{
                    borderTop: '1px solid #ABB7C0',
                    py: '30px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    mt: '4px'
                  }}>
                  </HelpText>
                </Box>
              </Box>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Box>
  )
}

export default ResetPassword;